import { DashboardResponseData } from "../types/api";
import axiosInstance from "../utils/axios";

export const getDashboard = async (token: string) => {
  try {
    const response = await axiosInstance.get<DashboardResponseData>(
      "/api/dashboard/"
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching dashboard:", error);
    throw new Error("Failed to fetch dashboard");
  }
};
